const dropdowns = document.querySelectorAll('.js-dropdown')

for (const dropdown of dropdowns) {
  dropdown.addEventListener('toggle', () => {
    if (dropdown.open) {
      for (const otherDropdown of dropdowns) {
        if (otherDropdown !== dropdown) {
          otherDropdown.open = false
        }
      }
    }
  })
}

const sorting = document.querySelector('.js-search-sorting')

if (sorting) {
  const active = sorting.querySelector('.is-active')?.innerText.trim()

  if (active) {
    const title = sorting.querySelector('.js-dropdown-title')
    title.innerText = `${title.innerText}: ${active}`
  }
}
